/** Hook to control the video and audio tracks of the local and shared streams */

import { isDev } from '@tunasong/models'
import { useCallback, useState } from 'react'
import { useDefaultInput } from '../default-input.js'
import { useAudioEngine } from './audio-engine.js'
import { useMixer } from './mixer.hook.js'

export const useMic = () => {
  const mixer = useMixer()
  const input = useDefaultInput()
  const engine = useAudioEngine()

  const [headsetMode, setHeadsetMode] = useState(false)
  const [isMuted, setIsMuted] = useState(isDev())
  const [isActive, setActive] = useState(false)

  const selectedDevice = engine.defaultInputDevice

  const mute = (m = true) => {
    if (!mixer) {
      return
    }
    // const channel = mixer.getChannels('mic')
    mixer.muteChannels('mic', m)
    const bus = mixer.getBus('mic')
    bus.muted = m
    setIsMuted(m)
  }

  const stop = useCallback(() => {
    if (!input) {
      return
    }
    setActive(false)
    input.monitor = false
  }, [input])

  /** Start the selected device */
  const start = useCallback(async () => {
    if (!input) {
      return
    }
    setActive(true)
    input.monitor = true
  }, [input])

  const setDefaultInputDevice = (newDevice: MediaDeviceInfo) => {
    if (!newDevice) {
      return
    }
    // eslint-disable-next-line react-compiler/react-compiler
    engine.defaultInputDevice = newDevice
  }

  const headset = (usingHeadset: boolean) => {
    // if (!micStream.current) {
    //   return
    // }
    setHeadsetMode(usingHeadset)

    // /** If using headset, turn off echo cancellation */
    // const constraints = usingHeadset ? micHeadset : micDefaults
    // micStream.current.getAudioTracks().forEach(async t => {
    //   await t.applyConstraints(constraints)
    //   logger.debug('Applied constraints to audio track', t.getConstraints())
    // })
  }

  return {
    /** The local and share streams. Video and audio tracks are managed by this hook */
    ready: Boolean(selectedDevice),
    selectedDevice,
    headset,
    headsetMode,
    isMuted,
    isActive,
    mute,
    setDevice: setDefaultInputDevice,
    start,
    stop,
  }
}

export type MicControl = ReturnType<typeof useMic>
